<section class="p-6">
  <div class="flex flex-row gap-2 justify-start items-center">
    <span class="f-s-20 flex-1">Add 303 Data Reporting Portal Worker Permits</span>
    <button mat-raised-button (click)="save()" color="primary" *ngIf="selectedPermits.length > 0">Add Selected Permits</button>
    <button mat-raised-button (click)="cancel()" color="warn">Cancel</button>
  </div>
</section>

<mat-dialog-content>
  <div class="m-t-8 flex flex-col">
    <form [formGroup]="workerPermitForm">
      <div class="flex flex-col lg:flex-row gap-2">
        <mat-form-field class="w-full lg:w-[60%]">
          <mat-label>Worker Permit Number</mat-label>
          <input matInput type="text" formControlName="permitId" placeholder="Permit Id">
          <mat-error *ngIf="workerPermitForm.get('permitId').invalid">
            Worker Permit could not be found
          </mat-error>
        </mat-form-field>

        <button mat-button type="button" color="primary" (click)="addPermit()" *ngIf="workerPermitForm.valid">
          Select
        </button>
      </div>
    </form>

    <div class="m-t-8 flex flex-col w-full">
      <span class="f-s-20">Selected Permits</span>
      <div class="flex flex-col w-full">
        <div *ngFor="let permit of selectedPermits" class="flex flex-row gap-2 justify-start items-center w-[80%]">
          <span class="w-1/2">{{ permit }}</span>
          <button mat-button type="button" color="warn" (click)="removePermit(permit)">
            Remove
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
